module.exports = __webpack_public_path__ + "static/img/zhifubao.8fd7bb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhifubao.jpg
// module id = y40n
// module chunks = 4